import {Injectable} from '@angular/core';
import {AdminService} from './admin.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs/Observable';


@Injectable()
export class ViewDocxService {

  // public docxFileALink = 'https://docs.google.com/gview?url=https://file-storage-encata.s3-eu-west-1.amazonaws.com/08-Aug-2018-12%3A14%3A52_prod_tmp_7319137719054852574Manage.1.15.05.15.docx&embedded=true';
  // public url = this.sanitizer.bypassSecurityTrustResourceUrl(this.docxFileALink);

  constructor(public adminService: AdminService,
              public modalService: NgbModal) {
  }


  getLinkByDocxID(): Observable<any> | null {
    const fileID = localStorage.getItem('DocxID');
    const sID = localStorage.getItem('DocxSID');

    if (fileID && sID) {
      return this.adminService.getTempDocxFileLink(fileID, sID);
    }
    return null;
  }

  deleteLinkByDocxID() {
  }

  deleteDocxManually(fileLink, sID) {
    return this.adminService.deleteTempDocxFileManually(fileLink, sID);
  }

  clearTempFileLoacalStorage() {
    localStorage.removeItem('DocxID');
    localStorage.removeItem('DocxSID');
  }

  deleteLinkByDocxIDManually() {
    localStorage.removeItem('fileLink');
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/view-docx.service.ts